import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { invoiceCompare } from 'src/api';
import {message} from 'antd';
import { MyStore } from 'kts-platform-frame/redux';

class ModulesAction extends ActionBasic<ModulesState> {
    public updateCompareList = async(params) => {
        const _listData = await  invoiceCompare.list(this, params);
        if (_listData.er || !_listData.res){
            return;
        } 
        this.modulesState.listData = _listData.res.items;
        this.modulesState.listPageTotal = await _listData.res.pageMeta.total;
        this.setModulesState();
    }

    public addCompare = async(params) => {
        const result = await invoiceCompare.addCompare(this, params);
        if (!result.er) {
            message.info('操作成功！');
        }
        await console.log(result.res);
    }

    public delCompare = async(params) => {
        await invoiceCompare.delCompare(this, params);
    }

    public queryBatch = async(params) => {
        const _statistics = await invoiceCompare.queryCompare(this, params);
        if (!_statistics.er ) {
            this.modulesState.statistics = _statistics.res.items[0];
            this.setModulesState();
        }
        
    }

    public delCompareDetail = async(params) =>{
        const result = await invoiceCompare.delCompareDetail(this, params);
    }

    public getDetail = async(params) => {
        const _detailData = await invoiceCompare.detail(this, params);
        if (_detailData.er || !_detailData.res){
            return;
        } 
        this.modulesState.detailData = _detailData.res.items;
        this.modulesState.detailPageTotal = await _detailData.res.pageMeta.total;
        if (this.modulesState.detailData.length> 0) {
            this.modulesState.detailDataIn = true;
        }
        this.setModulesState();
    }
    public handleDetailPageChange = async(page: number, id: number) => {

        if (this.modulesState.detailFields) {
            this.getDetail({compareBachId: id, pageNumber: page, pageSize: 10, ...this.modulesState.detailFields});
        } else {
            this.getDetail({ compareBachId: id,pageNumber: page, pageSize: 10});
        }
        this.modulesState.detailPageNumber = page;
    }
    public handlelistPageChange = async(page) =>{
        const { user } = MyStore.instance.getState();
        const companyId = user.userInfo.companyId;
        const userId = user.userInfo.cUserId;
        if (this.modulesState.listFields) {
            this.updateCompareList({ companyId, userId, pageNum: page, pageSize: 10, ...this.modulesState.detailFields});
        } else {
            this.updateCompareList({ companyId, userId,pageNum: page, pageSize: 10});
        }
        this.modulesState.listPageNumber = page;
    }
    public commitCompare = async(params) => {
        const result = await invoiceCompare.commitCompare(this, params);
        if (!result.er) {
            message.info('操作成功！');
        }
        
    }
}

export default new ModulesAction();



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceCompare/Modules.Action.ts